
import * as defaultImport from "@splunk/visualization-encoding/utils/colorUtils";
export * from "@splunk/visualization-encoding/utils/colorUtils";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
